import React from 'react'
import { Table, Button } from 'semantic-ui-react'
import { connect } from 'react-redux'

const findLastPlayed = (id, question_game) =>{
    const keys = Object.keys(question_game);
    var lastDate = null;
    for (var i = 0; i < keys.length; i++){
        if (keys[i] && keys[i].includes(id))
            if (question_game[keys[i]].ask_date != null)
                if (lastDate == null || lastDate < question_game[keys[i]].ask_date) 
                    lastDate = question_game[keys[i]].ask_date;
    }
    if (lastDate == null) return "Inedita"
    else return new Date(lastDate).toDateString()
}

const QuestionRow = ({ question, onAddClick, question_game }) => (
    <Table.Row>
        <Table.Cell>{question.topic}</Table.Cell>
        <Table.Cell>{question.text}</Table.Cell>
        <Table.Cell>{findLastPlayed(question.id, question_game)}</Table.Cell>
        <Table.Cell>
            <Button primary onClick={() => onAddClick(question)}>Aggiungi</Button>
        </Table.Cell>
    </Table.Row>
)

const QuestionsTable = ({ questions, onAddClick, question_game }) => (
    <Table>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Argomento</Table.HeaderCell>
                <Table.HeaderCell>Domanda</Table.HeaderCell>
                <Table.HeaderCell>Last played</Table.HeaderCell>
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {questions.map(question => <QuestionRow key={question.id} question={question} onAddClick={onAddClick} question_game = {question_game} />)}
        </Table.Body>
    </Table>
)

const mapStateToProps = ({ question_game}) => ({
    question_game
})

export default connect(
    mapStateToProps
)(QuestionsTable)


// WEBPACK FOOTER //
// ./src/components/QuestionsTable.js